import { isServer } from './EnvUtils';

interface IBreadcrumb {
  addBreadcrumb(payload: any): void,
  addAction(payload: any): void,
  addMutation(payload: any): void,
  getActions(): Array<any>,
  getMutations(): Array<any>,
  getBreadcrumbs(): Array<any>,
}

class Breadcrumb implements IBreadcrumb {
  actions: Array<any>;
  mutations: Array<any>;
  breadcrumbs: Array<any>;

  constructor() {
    this.actions = [];
    this.mutations = [];
    this.breadcrumbs = [];
  }

  addBreadcrumb(payload: any) {
    const currentDate = new Date();
    this.breadcrumbs = [`${payload}|${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`, ...(this.breadcrumbs.slice(0, 200))];
  }

  addAction(payload: any) {
    const currentDate = new Date();
    this.actions = [`${payload}|${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`, ...(this.actions.slice(0, 200))];
  }

  addMutation(payload: any) {
    const currentDate = new Date();
    this.mutations = [`${payload}|${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`, ...(this.mutations.slice(0, 500))];
  }

  getActions() {
    return this.actions;
  }

  getMutations() {
    return this.mutations;
  }

  getBreadcrumbs() {
    return this.breadcrumbs;
  }
}

class ServerBreadcrumb implements IBreadcrumb {
  addBreadcrumb(): void {
  }

  addAction(): void {
  }

  addMutation(): void {
  }

  getActions(): any[] {
    return [];
  }

  getMutations(): any[] {
    return [];
  }

  getBreadcrumbs(): any[] {
    return [];
  }
}

const serverCrumbs = isServer() ? new ServerBreadcrumb() : null;

let instance: IBreadcrumb | null = null;

export default function getInstance() {
  if (isServer()) {
    return serverCrumbs;
  }

  if (!instance) {
    instance = new Breadcrumb();
  }

  return instance;
}
